<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item>
              <div class="d-flex justify-content-end">
                <button class="btn btn-danger btn-sm" @click="volver">
                  volver
                </button>
              </div>
            </card-item>
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Historial de Contratos</h4>

                    <p class="card-category">Listado</p>
                  </div>
                </div>
              </template>
              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="label" for="quickFilter">
                        Filtro rapido
                      </label>

                      <input
                        id="quickFilter"
                        v-model="quickFilter"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label" for="startDate"
                        >Fecha de inicio</label
                      >
                      <input
                        id="startDate"
                        v-model="startDate"
                        class="form-control"
                        type="date"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label" for="endDate">Fecha de fin</label>
                      <input
                        id="endDate"
                        v-model="endDate"
                        class="form-control"
                        type="date"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label" for="id_cliente">Cliente</label>
                      <SelectorClienteVigente v-model="cliente" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label">&nbsp;</label>
                      <button
                        class="btn btn-primary form-control"
                        @click="applyDateFilter"
                      >
                        Aplicar filtro
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :rowData="usuariosData"
                      @grid-ready="onGridReady"
                      :gridOptions="gridOptions"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import { get } from "lodash-es";
import SelectorClienteVigente from "./shared/SelectorClienteVigente.vue";

export default {
  name: "HistorialContratos",
  components: {
    AgGridVue,
    SelectorClienteVigente,
  },
  beforeMount() {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    this.startDate = this.formatDate(oneYearAgo);
    this.endDate = this.formatDate(today);
  },
  data: () => ({
    cliente: null,
    quickFilter: "",
    startDate: "",
    endDate: "",

    // ag-grid config
    modules: AllModules,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },

    gridApi: null,

    defaultColDef: {
      wrapHeaderText: true,
      autoHeaderHeight: true,
      maxWidth: 120,
      sortable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },

    usuariosData: [],
    columnDefs: [
      {
        headerName: "#",
        field: "id_contrato_historial",
        sort: "desc",
        hide: true,
      },
      { headerName: "Nombre Web", field: "nombre_web", maxWidth: 200 },
      { headerName: "Patente", field: "patente" },
      {
        headerName: "Fecha Historial",
        valueGetter: (params) => {
          return moment(params.data.fecha_historial).format("LLLL");
        },
        minWidth: 280,
        maxWidth: 300,
      },
      {
        headerName: "Motivo Historial",
        field: "motivo_historial",
        maxWidth: 200,
      },
      {
        headerName: "Comentarios Historial",
        field: "comentarios_historial",
        maxWidth: 200,
        hide: true,
      },
      { headerName: "ID Contrato", field: "id_contrato" },
      { headerName: "ID Cliente", field: "id_cliente" },
      { headerName: "ID Vehículo", field: "id_vehiculo" },
      { headerName: "ID AVL", field: "id_avl" },
      { headerName: "ID Chip", field: "id_chip" },
      { headerName: "Tipo Contrato", field: "tipo_contrato", hide: true },
      {
        headerName: "Fecha Alta",
        field: "fecha_alta",
        valueGetter: (params) => {
          return moment(params.data.fecha_historial).format("DD/MM/YYYY");
        },
      },
      { headerName: "Precio", field: "precio", hide: true },
      { headerName: "Convenio", field: "convenio", hide: true },
      { headerName: "ID Grupo", field: "id_grupo", hide: true },
      { headerName: "Por ID Cliente", field: "por_id_cliente", hide: true },
      {
        headerName: "ID Contrato Tipos",
        field: "id_contrato_tipos",
        hide: true,
      },
    ],
  }),

  methods: {
    volver() {
      this.$router.push("/admin/clientes");
    },
    formatDate(date) {
      return date.toISOString().split("T")[0];
    },
    async update() {
      this.getData();
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getData() {
      this.gridApi.showLoadingOverlay();
      const resp = await axios.post("/execute", {
        method: "CLI.GetHistorialContratos",
        parameters: [
          {
            name: "StartDate",
            value: this.startDate || null,
          },
          {
            name: "EndDate",
            value: this.endDate || null,
          },
          {
            name: "IdCliente",
            value: this.cliente ? this.cliente.id_cliente : null,
          },
        ],
      });
      if (resp.data.ok) {
        this.usuariosData = get(resp, "data.result[0]", []);
        this.gridApi.hideOverlay();
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getData();
    },
    validateDateRange() {
      if (this.cliente) return true;

      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 370) {
          this.$msgBoxOk("El rango de fechas no puede ser mayor a un año.");
          this.endDate = "";
          return false;
        }

        return true;
      }
      this.$msgBoxOk(
        "Por favor, seleccione ambas fechas para aplicar el filtro.",
      );
      return false;
    },
    applyDateFilter() {
      if (this.validateDateRange()) this.getData();
    },
  },
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style></style>
